import { AxiosRequestConfig } from 'axios';
import { inject, injectable, interfaces } from 'inversify';
import moment from 'moment';
import { ACDLError } from '../../../../../__legacy__/models/error.model';
import { IMainApiService, MainApiService } from '../../../../../__legacy__/services/api.service';
import { TimePeriod } from '../../../../../design/selects/timePeriodSelector/S_TimePeriodSelector';
import { IAnnotationToolsStatsExportModel, IGeneralStatsExportModel, IWorkPerformanceStatsExportModel } from './models/ExportProjectStatsModels';

export interface IExportProjectStatsRequest {
  projectId: string;
  timePeriod: TimePeriod;
  startDate: moment.Moment;
  endDate: moment.Moment;
  generalStats: IGeneralStatsExportModel[];
  annotationToolsStats: IAnnotationToolsStatsExportModel[];
  workPerformanceStats: IWorkPerformanceStatsExportModel[];
}

export interface IExportProjectStatsService {
  exportStatsAsync(request: IExportProjectStatsRequest): Promise<void>;
}

export namespace IExportProjectStatsService {
  export const $: interfaces.ServiceIdentifier<IExportProjectStatsService> = Symbol('EXPORT_PROJECT_STATS_SERVICE');
}

@injectable()
export class ExportProjectStatsService implements IExportProjectStatsService {
  constructor(@inject(IMainApiService.$) private readonly apiService: MainApiService) {}

  async exportStatsAsync(request: IExportProjectStatsRequest): Promise<void> {
    const config: AxiosRequestConfig = {};
    config.method = 'POST';
    config.data = request;

    const result = await this.apiService.getFileAsync('/Projects/DownloadProjectStats', config);

    if (result instanceof ACDLError) {
      throw result;
    }
  }
}
